import md5 from "md5";
export const TokenFn = (...args: any): string => {
  const str = JSON.stringify(args);
  const token = md5(str);
  return token;
};
